import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import locales from 'locales';
import config from 'config';

class Notification extends Component {
  constructor(props) {
    super(props);
    this.notificationSystem = React.createRef();
  }

  shouldComponentUpdate(nextProps) {
    const { notification } = this.props;
    return nextProps.notification !== notification;
  }

  componentDidUpdate() {
    const { notification, user: { language } } = this.props;
    const notificationDefaultProps = {
      position: 'br',
      autoDismiss: 3,
    };

    const notificationMessageInLocale = locales[language][notification.message];

    if (!notification.level) {
      notification.level = config.notificationLevels.info;
    }

    const finalNotification = Object.assign({}, notificationDefaultProps, notification, {
      message: notificationMessageInLocale,
    });

    this.notificationSystem.current.addNotification(finalNotification);
  }

  render() {
    return (
      <NotificationSystem ref={this.notificationSystem} />
    );
  }
}

Notification.propTypes = {
  notification: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapSateToProps = state => ({
  notification: state.notification,
  user: state.user,
});

export default connect(mapSateToProps)(Notification);



// WEBPACK FOOTER //
// ./src/components/Notifications.jsx